import React, { useEffect, useState, useRef } from "react";
import Header from "./Header";
import User2 from "../img/User2.svg";
import User1 from "../img/User1.svg";
import RightPurple from "../img/RightPurple.svg";
import Setting_line from "../img/Setting_line.svg";
import SettingLog from "../img/SettingLog.svg";
import ProfileImg from "../img/ProfileImg.svg";
import api from "../../api/axiosInstance";
import callIcon from "../img/call_icon.svg";
import emailIcon from "../img/EmailIcon.svg";
import UserIcon from "../img/UserIcon.svg";
import Add_round2 from "../img/Add_round2.svg";
import CompanyIcon from "../img/CompanyIcon.svg";
import PhoneInput from "react-phone-input-2";
import { useNavigate } from "react-router-dom";

const Profile = () => {
  const [activeTab, setActiveTab] = useState("profile");
  const [isEditing, setIsEditing] = useState(false);
  const navigate = useNavigate();
  const [showSizeErrorModal, setShowSizeErrorModal] = useState(false);
  const [sizeErrorMessage, setSizeErrorMessage] = useState("");
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const sidebarRef = useRef(null);
  const [passwordLastChanged, setPasswordLastChanged] = useState("");

  const [profile, setProfile] = useState({});

  const [formData, setFormData] = useState({
    first_name: "",
    company_name: "",
    country_code: "",
    email: "",
    phone_number: "",
    profile_pic: null, // ← File object
  });
  const [errors, setErrors] = useState({
    first_name: "",
    company_name: "",
  });

  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    api
      .get("/display/api/v1/read-update-profile", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        if (res.data.status === "success") {
          const fetchedProfile = res.data.data;
          setProfile(fetchedProfile);
          setFormData({
            first_name: fetchedProfile.first_name || "",
            company_name: fetchedProfile.company_name || "",
            email: fetchedProfile.email || "",
            phone_number: fetchedProfile.phone_number || "",
            country_code: fetchedProfile.country_code || "",
            profile_pic: fetchedProfile.profile_pic || "",
          });
        }
        const passwordChangeTime = calculatePasswordChangeTime(
          res.data.data?.user_details?.last_password_change_date
        );
        setPasswordLastChanged(passwordChangeTime);
      })
      .catch((err) => {
        console.error("Error fetching profile:", err);
      });
  }, []);

  const handleSave = () => {
    const newErrors = {
      first_name: formData.first_name ? "" : "Enter your name",
      company_name: formData.company_name ? "" : "Enter your company name.",
    };

    if (newErrors.first_name || newErrors.company_name) {
      setErrors(newErrors);
      return;
    }
    const token = localStorage.getItem("accessToken");

    const payload = new FormData();
    payload.append("first_name", formData.first_name);
    payload.append("company_name", formData.company_name);
    // payload.append("country_code", formData.country_code || "");
    // payload.append("email", formData.email || "");
    // payload.append("phone_number", formData.phone_number || "");

    if (formData.profile_pic instanceof File) {
      payload.append("profile_pic", formData.profile_pic);
    }

    api
      .patch("/display/api/v1/read-update-profile", payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        if (res.data.status === "success") {
          // alert("Profile updated successfully!");

          // 🔄 Fetch updated profile data from server
          api
            .get("/display/api/v1/read-update-profile", {
              headers: { Authorization: `Bearer ${token}` },
            })
            .then((res) => {
              if (res.data.status === "success") {
                setProfile(res.data.data); // update display
                setFormData((prev) => ({
                  ...prev,
                  profile_pic: null, // reset file preview
                }));
                setIsEditing(false); // hide edit container
              }
            });
        }
      })
      .catch((err) => {
        console.error("Error updating profile:", err);
      });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setSidebarOpen(false);
      }
    };

    if (sidebarOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [sidebarOpen]);

  const calculatePasswordChangeTime = (lastPasswordChangeDate) => {
    if (!lastPasswordChangeDate) return "Not changed yet";

    const now = new Date();
    const lastChange = new Date(lastPasswordChangeDate);
    const diffTime = Math.abs(now - lastChange);

    // Calculate all time units
    const diffYears = Math.floor(diffTime / (1000 * 60 * 60 * 24 * 365));
    const diffMonths = Math.floor(diffTime / (1000 * 60 * 60 * 24 * 30));
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    const diffHours = Math.floor(
      (diffTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const diffMinutes = Math.floor((diffTime % (1000 * 60 * 60)) / (1000 * 60));

    if (diffYears > 0) {
      return `${diffYears} year${diffYears > 1 ? "s" : ""} ago`;
    } else if (diffMonths > 0) {
      return `${diffMonths} month${diffMonths > 1 ? "s" : ""} ago`;
    } else if (diffDays > 0) {
      return `${diffDays} day${diffDays > 1 ? "s" : ""} ago`;
    } else if (diffHours > 0) {
      return `${diffHours} hour${diffHours > 1 ? "s" : ""} ago`;
    } else if (diffMinutes > 0) {
      return `${diffMinutes} minute${diffMinutes > 1 ? "s" : ""} ago`;
    } else {
      return "Just now";
    }
  };

  return (
    <div>
      <Header></Header>
      {/* Mobile Top Bar with Hamburger */}
      <div className="md:hidden flex justify-between items-center px-4 py-3 bg-white shadow">
        <button
          onClick={() => setSidebarOpen(true)}
          className="text-3xl"
          aria-label="Open sidebar"
        >
          &#9776;
        </button>
      </div>

      <div
        ref={sidebarRef}
        className={`fixed top-0 left-0 h-full w-1/2 bg-white shadow-lg z-50 py-4 overflow-y-auto transition-all duration-500 ease-in-out ${
          sidebarOpen
            ? "translate-x-0 opacity-100"
            : "-translate-x-full opacity-0"
        }`}
      >
        <div className="flex justify-between items-center px-4 py-3 border-b">
          <h2 className="text-lg font-semibold">Menu</h2>
          <button
            onClick={() => setSidebarOpen(false)}
            className="text-2xl font-bold"
          >
            &times;
          </button>
        </div>

        <div className="flex flex-col gap-4">
          <div
            className={`flex items-center gap-3 cursor-pointer p-2 rounded ${
              activeTab === "profile" ? "bg-[#F7F2FF]" : ""
            }`}
            onClick={() => {
              setActiveTab("profile");
              setSidebarOpen(false);
            }}
          >
            <img src={activeTab === "profile" ? User2 : User1} alt="Profile" />
            <span
              className={`${
                activeTab === "profile" ? "text-[#9061DB]" : "text-black"
              }`}
            >
              Profile
            </span>
          </div>

          <div
            className={`flex items-center gap-3 cursor-pointer p-2 rounded ${
              activeTab === "settings" ? "bg-[#F7F2FF]" : ""
            }`}
            onClick={() => {
              setActiveTab("settings");
              navigate("/SettingsPage", {
                state: {
                  passwordLastChanged: passwordLastChanged,
                },
              });
              setSidebarOpen(false);
            }}
          >
            <img
              src={activeTab === "settings" ? SettingLog : Setting_line}
              alt="Settings"
            />
            <span
              className={`${
                activeTab === "settings" ? "text-[#9061DB]" : "text-black"
              }`}
            >
              Settings
            </span>
          </div>
        </div>
      </div>

      <div className="flex  flex-col md:flex-row px-4 md:px-10 py-6 w-full fixed">
        {/* Sidebar */}
        <div className="md:flex hidden gap-2 flex-col w-full md:w-2/12 mb-6 md:mb-0 font-semibold">
          {/* Profile Tab */}
          <div
            className="flex items-center gap-3 cursor-pointer h-9 rounded"
            onClick={() => setActiveTab("profile")}
          >
            <div
              className="w-1 h-5 rounded"
              style={{
                backgroundColor:
                  activeTab === "profile" ? "#9061DB" : "transparent",
              }}
            ></div>
            <img
              src={activeTab === "profile" ? User2 : User1}
              alt="Profile Icon"
            />
            <span
              style={{ color: activeTab === "profile" ? "#9061DB" : "black" }}
            >
              Profile
            </span>
            {activeTab === "profile" && <img src={RightPurple} alt="arrow" />}
          </div>

          {/* Settings Tab */}
          {/* <div
            className="flex items-center gap-3 cursor-pointer"
            onClick={() => setActiveTab("settings")}
          > */}

          <div
            className={`flex items-center gap-3 cursor-pointer h-9 rounded hover:bg-[#F7F2FF] ${
              activeTab !== "settings" ? "" : ""
            }`}
            onClick={() => {
              setActiveTab("settings");
              navigate("/SettingsPage", {
                state: {
                  passwordLastChanged: passwordLastChanged,
                },
              }); // adjust path as per your route
            }}
          >
            <div
              className="w-1 h-5 rounded"
              style={{
                backgroundColor:
                  activeTab === "settings" ? "#9061DB" : "transparent",
              }}
            ></div>

            <img
              src={activeTab === "settings" ? SettingLog : Setting_line}
              alt="Profile Icon"
            />
            <span
              style={{ color: activeTab === "settings" ? "#9061DB" : "black" }}
            >
              Settings
            </span>
            {activeTab === "settings" && <img src={RightPurple} alt="arrow" />}
          </div>
        </div>

        {/* Separator Line */}
        <div className="hidden md:block w-px bg-gray-300 h-screen" />

        {/* Content */}
        <div className="px-4 md:px-10  w-full md:w-10/12">
          <h1 className="text-2xl font-semibold">Profile Details</h1>

          {/* Display Container */}
          {!isEditing && (
            <div
              className="py-5 rounded mt-5 border border-[#D9D9D9] "
              style={{ boxShadow: "0px 1px 4px 0px #00000040" }}
            >
              <div className="px-5">
                {/* Header: Profile Pic + Name + Edit */}
                <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
                  {/* Profile Picture and Info */}
                  <div className="flex gap-4 items-center">
                    <img
                      src={profile.profile_pic || ProfileImg}
                      alt="Profile"
                      className="h-20 w-20 rounded-full object-cover border border-gray-300 shadow"
                    />
                    <div className="flex flex-col">
                      <span className="text-xl sm:text-2xl font-semibold">
                        {profile.first_name}
                      </span>
                      <span className="text-sm sm:text-base text-gray-700 max-w-[350px]  break-words">
                        {profile.email}
                      </span>
                    </div>
                  </div>

                  {/* Edit Button */}
                  <button
                    className="font-semibold text-sm h-9 w-full sm:w-24 text-white rounded"
                    style={{
                      background:
                        "linear-gradient(270deg, #9061DB 0%, #8777F3 100%)",
                    }}
                    onClick={() => setIsEditing(true)}
                  >
                    Edit
                  </button>
                </div>

                {/* Info Grid */}
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-6">
                  <div className="flex flex-col">
                    <span className="text-sm text-gray-600">Company Name</span>
                    <span className="text-sm mt-2 font-medium">
                      {profile.company_name}
                    </span>
                  </div>

                  <div className="flex flex-col">
                    <span className="text-sm text-gray-600">Mobile Number</span>
                    <span className="text-sm mt-2 font-medium">
                      {profile.phone_number}
                    </span>
                  </div>

                  <div className="flex flex-col">
                    <span className="text-sm text-gray-600">Domain Name</span>
                    <span className="text-sm mt-2 font-medium">
                      {profile.domain}.onzitr.com
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Edit Container */}
          {isEditing && (
            <div className="py-5 rounded mt-5 border border-[#D9D9D9] shadow">
              <div className="px-5">
                <div className="flex justify-between items-start md:items-center gap-4">
                  <div className="flex gap-2">
                    <div className="w-28 mb-4 relative">
                      {/* Profile Picture Preview */}
                      <img
                        src={
                          formData.profile_pic instanceof File
                            ? URL.createObjectURL(formData.profile_pic)
                            : profile.profile_pic || ProfileImg
                        }
                        alt="Profile"
                        className="h-24 w-24 rounded-full object-cover border border-gray-300"
                      />

                      {/* Hidden file input with label trigger */}
                      <label className="cursor-pointer text-sm text-blue-600 hover:underline absolute bottom-[1px] right-2 w-5 h-5 border border-2 border-[#9061DB] rounded-full">
                        <img src={Add_round2} alt="" />
                        <input
                          type="file"
                          accept="image/*"
                          onChange={(e) => {
                            const file = e.target.files[0];

                            if (file) {
                              if (file.size > 20 * 1024 * 1024) {
                                setSizeErrorMessage(
                                  "Please choose a file smaller than 20MB."
                                );
                                setShowSizeErrorModal(true);
                                return;
                              }

                              if (file.type.startsWith("image/")) {
                                setFormData((prev) => ({
                                  ...prev,
                                  profile_pic: file,
                                }));
                              } else {
                                alert("Please select a valid image file.");
                              }
                            }
                          }}
                          className="hidden"
                        />
                      </label>
                    </div>
                  </div>

                  <button
                    className="font-bold text-sm h-8 w-20 text-white rounded"
                    onClick={handleSave} // ← THIS was missing
                    style={{
                      background:
                        "linear-gradient(270deg, #9061DB 0%, #8777F3 100%)",
                    }}
                  >
                    Save
                  </button>
                </div>

                <div className="flex flex-col  mt-5 w-full gap-5">
                  <div className="flex  gap-4 w-full">
                    {/* Name */}
                    <div className="w-1/2">
                      <label className="block text-sm mb-1 font-normal font-inter">
                        Name <span className="text-red-500">*</span>
                      </label>
                      <div className="relative">
                        <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-black">
                          <img
                            src={UserIcon}
                            className="h-5 w-5"
                            alt="User Icon"
                          />
                        </span>
                        <input
                          type="text"
                          className="w-full pl-10 pr-4 py-2 border-2 border-[#9061DB] bg-transparent rounded-md font-inter focus:outline-none focus:ring-2 focus:ring-[#9061DB]"
                          placeholder="Enter your name"
                          name="first_name"
                          value={formData.first_name}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              first_name: e.target.value,
                            }))
                          }
                          disabled={!isEditing}
                        />
                      </div>

                      {errors.first_name && (
                        <p className="text-sm text-red-500 mt-1">
                          {errors.first_name}
                        </p>
                      )}
                    </div>

                    {/* Company Name */}
                    <div className="w-1/2">
                      <label className="block text-sm mb-1 font-normal font-inter">
                        Company Name <span className="text-red-500">*</span>
                      </label>

                      <div className="relative">
                        <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-black">
                          <img
                            src={CompanyIcon}
                            className="h-5 w-5"
                            alt="Company Icon"
                          />
                        </span>
                        <input
                          type="text"
                          className="w-full pl-10 pr-4 py-2 border-2 border-[#9061DB] bg-transparent rounded-md font-inter focus:outline-none focus:ring-2 focus:ring-[#9061DB]"
                          placeholder="Enter your company name"
                          name="company_name"
                          maxLength={50}
                          value={formData.company_name}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              company_name: e.target.value,
                            }))
                          }
                          disabled={!isEditing}
                        />
                      </div>

                      {errors.company_name && (
                        <p className="text-sm text-red-500 mt-1">
                          {errors.company_name}
                        </p>
                      )}
                    </div>
                  </div>

                  <div className="flex  gap-4 w-full">
                    {/* Business Email */}
                    <div className="w-1/2">
                      <label className="block text-sm mb-1 font-normal font-inter">
                        Business Email
                      </label>
                      <div className="relative">
                        <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-black">
                          <img
                            src={emailIcon}
                            className="h-5 w-5"
                            alt="Email Icon"
                          />
                        </span>
                        <input
                          type="text"
                          className="w-full bg-gray-200 pl-10 pr-4 py-2 border-2 border-[#9061DB]  rounded-md font-inter focus:outline-none focus:ring-2 focus:ring-[#9061DB]"
                          placeholder="Business email"
                          disabled
                          value={profile.email}
                        />
                      </div>
                    </div>
                    {/* Phone Number */}
                    <div className="w-1/2">
                      <label className="block text-sm mb-1 font-normal font-inter">
                        Mobile Number
                      </label>
                      <div className="relative">
                        <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-black">
                          <img
                            src={callIcon}
                            className="h-5 w-5"
                            alt="Phone Icon"
                          />
                        </span>
                        <input
                          type="text"
                          className="w-full w-full bg-gray-200 pl-10 pr-4 py-2 border-2 border-[#9061DB]  rounded-md font-inter focus:outline-none focus:ring-2 focus:ring-[#9061DB]"
                          placeholder="Phone number"
                          disabled
                          value={profile.phone_number}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {showSizeErrorModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-96">
            <h2 className="text-lg font-semibold mb-4 text-center">
              File Upload Error
            </h2>
            <p className="text-sm text-gray-700 text-center">
              {sizeErrorMessage}
            </p>
            <div className="mt-6 flex justify-center">
              <button
                className="bg-purple-600 hover:bg-purple-700 text-white px-6 py-2 rounded"
                onClick={() => setShowSizeErrorModal(false)}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Profile;
